/**
 * The locales Symmy ships a message catalogue for, and the one it falls back to.
 *
 * Labels are endonyms rather than translated names: this list is read *before*
 * the choice takes effect, so "Deutsch" is recognisable to someone who cannot
 * read "German" written in Czech. They are therefore not `<Trans>`-wrapped.
 *
 * Mirrors `Organization.Language` on the backend — the model's choices are what
 * actually validate a write, so the two lists must agree.
 */
export const LANGUAGES: { code: LanguageCode; label: string }[] = [
  { code: 'cs', label: 'Čeština' },
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
];

/**
 * Used when no organization is active yet — the login screen, the moment before
 * the organization list resolves, or an account with no membership at all.
 * Czech, because that is also every organization's default.
 */
export const DEFAULT_LANGUAGE: LanguageCode = 'cs';

/** The profile value meaning "follow the active organization". */
export const AUTO_LANGUAGE = 'auto';

export const languageLabel = (code: LanguageCode): string =>
  LANGUAGES.find((language) => language.code === code)?.label ?? code;

/** Narrow an untrusted string (localStorage, an API payload) to a real locale. */
export const isLanguageCode = (value: unknown): value is LanguageCode =>
  LANGUAGES.some((language) => language.code === value);
